"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelTask = cancelTask;
exports.createSyncMenuTask = createSyncMenuTask;
exports.deleteTask = deleteTask;
exports.getAsyncTaskList = getAsyncTaskList;
exports.getTaskDetail = getTaskDetail;
exports.getTaskProgress = getTaskProgress;
exports.retryTask = retryTask;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 异步任务管理相关接口
// 用于管理系统中的异步执行任务

/**
 * 获取异步任务列表
 * @param {Object} params - 查询参数
 * @param {Number} params.page - 页码
 * @param {Number} params.size - 每页大小
 * @param {String} params.taskType - 任务类型
 * @param {String} params.status - 任务状态
 * @param {Number} params.businessId - 业务ID
 * @param {String} params.businessType - 业务类型
 */
function getAsyncTaskList(params) {
  return (0, _requestPIM.default)({
    url: '/malldeli/asyncTask/list',
    method: 'get',
    params: params
  });
}

/**
 * 查询任务进度
 * @param {Number} taskId - 任务ID
 */
function getTaskProgress(taskId) {
  return (0, _requestPIM.default)({
    url: '/malldeli/asyncTask/progress',
    method: 'get',
    params: {
      taskId: taskId
    }
  });
}

/**
 * 取消任务
 * @param {Object} data - 取消参数
 * @param {Number} data.taskId - 任务ID
 */
function cancelTask(data) {
  return (0, _requestPIM.default)({
    url: '/malldeli/asyncTask/cancel',
    method: 'post',
    data: data
  });
}

/**
 * 重试任务
 * @param {Object} data - 重试参数
 * @param {Number} data.taskId - 任务ID
 */
function retryTask(data) {
  return (0, _requestPIM.default)({
    url: '/malldeli/asyncTask/retry',
    method: 'post',
    data: data
  });
}

/**
 * 删除任务
 * @param {Object} data - 删除参数
 * @param {Number} data.taskId - 任务ID
 */
function deleteTask(data) {
  return (0, _requestPIM.default)({
    url: '/malldeli/asyncTask/delete',
    method: 'post',
    data: data
  });
}

/**
 * 创建同步菜单任务
 * @param {Object} data - 任务参数
 * @param {Number} data.id - 模板ID
 * @param {Array<Number>} data.source - 来源场景
 * @param {Array<Number>} data.to - 目标场景
 */
function createSyncMenuTask(data) {
  return (0, _requestPIM.default)({
    url: '/malldeli/asyncTask/createSyncMenu',
    method: 'post',
    data: data
  });
}

/**
 * 获取任务详情
 * @param {Number} taskId - 任务ID
 */
function getTaskDetail(taskId) {
  return (0, _requestPIM.default)({
    url: '/malldeli/asyncTask/detail',
    method: 'get',
    params: {
      taskId: taskId
    }
  });
}